import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../service/auth';

async function runAuthGate(): Promise<boolean | UrlTree> {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isLoggedIn) {
    return true;
  }

  await auth.logout();
  return router.createUrlTree(['/login']);
}

/**
 * For `canActivate` on protected routes.
 */
export const authGuard: CanActivateFn = () => runAuthGate();

/**
 * Same rules as `authGuard`, for `canMatch`.
 */
export const authCanMatchGuard: CanMatchFn = () => runAuthGate();
